export const applePaymentRequestParams = {
  supportedNetworks: ['visa', 'masterCard', 'amex', 'discover'],
  merchantCapabilities: ['supports3DS', 'supportsCredit', 'supportsDebit'],
  total: {
    label: 'X24.TRANS',
    amount: '0', // assigned in the component
  },
  currencyCode: 'UAH',
  countryCode: 'UA',
}
